import {NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {FormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {MomentModule} from 'ngx-moment';
import {AuthInterceptor} from './framework/http-interceptors/auth-interceptor';
import {RequestCache, RequestCacheWithMap} from './framework/services/request-cache.service';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserModule} from '@angular/platform-browser';
import {FrameworkModule} from './framework/framework.module';
import {LOCALE_ID} from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeDE from '@angular/common/locales/de';
import {BusinessContactModule} from './business-contact/business-contact.module';
import { GuidesComponent } from './guides/guides.component';

registerLocaleData(localeDE);


@NgModule({
    declarations: [
        AppComponent,
        GuidesComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        MomentModule,
        AppRoutingModule,
        HttpClientModule,
        FrameworkModule,
        BusinessContactModule
    ],
    providers: [
        {provide: RequestCache, useClass: RequestCacheWithMap},
        {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
        { provide: LOCALE_ID, useValue: 'de-DE' },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
